import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import TeamWebhooksForm from './components/TeamWebhooksForm';
import Table from '../../shared/table/Table';

class TeamWebhooksPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.saveWebhook = this.saveWebhook.bind(this);
    this.saveWebhookRow = this.saveWebhookRow.bind(this);
    this.openModal = this.openModal.bind(this);
    this.loadWebhooks = this.loadWebhooks.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onFormChange = this.onFormChange.bind(this);

    this.columns = [
      {
        id: 'title',
        title: 'Title',
      },
      {
        id: 'url',
        title: 'URL',
      },
      {
        id: 'type',
        title: 'Type',
        type: 'select',
      },
    ];
  }

  componentDidMount() {
    this.props.getSupportedWebhooks();
    this.loadWebhooks();
  }

  componentDidUpdate(prevProps, prevState) {
    const isDifferentTeam = this.props.team && (!prevProps.team || prevProps.team.id !== this.props.team.id);
    if (isDifferentTeam) {
      this.loadWebhooks();
    }
  }

  loadWebhooks() {
    this.props.getWebhooks(this.props.team);
  }

  saveWebhook() {
    this.props.setWebhook(this.props.team, this.props.form);
  }

  saveWebhookRow(index, row) {
    this.props.updateWebhook(this.props.team, row);
  }

  onFormChange(event) {
    let form = this.props.form;
    // Tiny 'hack' for handling react-select's onChange.
    if (Object.prototype.hasOwnProperty.call(event, 'internal_name')) {
      form.type = event.id;
    } else {
      form[event.target.name] = event.target.value;
    }
    return this.props.set({ form });
  }

  openModal() {
    this.props.set({ modalIsOpen: true });
  }

  closeModal() {
    this.props.set({ modalIsOpen: false });
  }

  render() {
    let { webhooks, supported } = this.props;
    const hasPermission = this.props.checkPlanPermission('webhooks') || false;

    const editableColumns = {
      url: {},
      title: {},
      type: {
        validValues: supported,
      },
    };

    const bulkActions = [
      {
        text: 'Delete selected',
        className: ' danger',
        hasPermission,
        onClick: (webhooks) => {
          this.props.deleteWebhooks(this.props.team, webhooks);
        },
      },
      {
        text: 'Add webhook',
        hasPermission,
        bypassCheck: true,
        onClick: (e) => {
          this.openModal();
        },
      },
    ];

    return (
      <div>
        <div className="title-container">
          <h2>Webhooks</h2>
        </div>
        <div className="main-content-container">
          <p> You can use Webhooks to trigger external events based on activity in everviz. </p>
          <Modal
            isOpen={this.props.modalIsOpen}
            className="hc-modal-content"
            appElement={document.querySelector('.page-container')}
            overlayClassName="hc-modal-overlay"
            onRequestClose={this.closeModal}
            contentLabel="Webhook Modal"
          >
            <TeamWebhooksForm
              onSave={this.saveWebhook}
              onClose={this.closeModal}
              onFormChange={this.onFormChange}
              form={this.props.form}
              types={supported}
            />
          </Modal>

          <Table
            onRowSave={this.saveWebhookRow}
            editableColumns={editableColumns}
            columns={this.columns}
            rows={webhooks}
            dataReturned={true}
            bulkActions={bulkActions}
            pagePosition="bottom"
            className={'page-bottom'}
            hideLoading={true}
          />
        </div>
      </div>
    );
  }
}

TeamWebhooksPage.propTypes = {
  team: PropTypes.object.isRequired,
  paths: PropTypes.object.isRequired,
};

export default TeamWebhooksPage;
